import { render, staticRenderFns } from "./addInstrument.vue?vue&type=template&id=3a992a46&"
import script from "./addInstrument.vue?vue&type=script&lang=js&"
export * from "./addInstrument.vue?vue&type=script&lang=js&"
import style0 from "./addInstrument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports